import { RequestError } from 'src/common-services'

export function isAuthError(error: Error): error is RequestError {
  if (error instanceof RequestError) {
    const { status } = error
    return status === 401 || status === 402 || status === 409
  }
  return false
}
